import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { blue, salmon } from '../../theme';
import { trim } from 'ramda';
import CriticalWarningIcon from '../svg-icons/critical-warning-icon';
import WarningIcon from '../svg-icons/warning-icon';
import SuccessIcon from '../svg-icons/success-icon';

const CaseField = (props) => {
  const {
    heading,
    showPlusIcon,
    showIsRequired,
    className = '',
    handleOnClickPlusIcon,
    plusIconLabel = '',
    searchText = ''
  } = props;

  const styles = StyleSheet.create({
    caseFieldContainer: {
      fontSize: '14px',
      minHeight: '24px'
    },
    heading: {
      color: blue[200]
    },
    caseFieldPlusIcon: {
      fontSize: '16px',
      color: blue[500]
    },
    requiredText: {
      color: salmon[500]
    },
    iconPadding: {
      paddingBottom: '2px'
    },
    iconPaddingLeft: {
      paddingLeft: '1px'
    },
    searchText: {
      marginLeft: '6px',
      paddingBottom: '2px',
      fontWeight: '700',
      color: blue[500]
    }
  });

  return (
    <div
      className={trim(`${className} ${css(styles.caseFieldContainer)}`)}
      style={{ ...props.style }}
    >
      <div className='fx fx__v-center'>
        {props.showAlert && !props.showNoneFlag && <CriticalWarningIcon className={css(styles.iconPadding)} height={16} />}
        {!props.showAlert && !props.showIncomplete && !props.showNoneFlag && <SuccessIcon className={css(styles.iconPadding)} height={18} />}
        {props.showIncomplete && !props.showNoneFlag && <WarningIcon className={css(styles.iconPadding)} height={20} />}
        {props.showNoneFlag &&
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" style={{ marginTop: '-4px' }}>
            <path fill="#96C8FF" fillRule="evenodd" d="M8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8ZM1.714 8.029c0-3.452 2.855-6.248 6.379-6.248 1.475 0 2.83.492 3.907 1.32l-8.938 8.754A6.091 6.091 0 0 1 1.714 8.03ZM4 12.904a6.385 6.385 0 0 0 3.907 1.32c3.524 0 6.379-2.796 6.379-6.247a6.091 6.091 0 0 0-1.348-3.827L4 12.904Z" clipRule="evenodd" />
          </svg>
        }
        <div className={`ml-2 fx fx__v-center ${css(styles.heading)}`}>
          <span className='pb-1 font-14__bold'>
            {heading}
          </span>
          {props.showSearchIcon &&
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="none"
                className='ml-2'
              >
                <path
                  fill={blue[500]}
                  fillRule="evenodd"
                  d="M10.712 10.063h.723L16 14.637 14.637 16l-4.574-4.565v-.723l-.247-.256a5.92 5.92 0 0 1-3.87 1.437 5.946 5.946 0 1 1 5.947-5.947 5.92 5.92 0 0 1-1.437 3.87l.256.247ZM1.83 5.947a4.111 4.111 0 0 0 4.117 4.116 4.111 4.111 0 0 0 4.116-4.116A4.111 4.111 0 0 0 5.947 1.83 4.111 4.111 0 0 0 1.83 5.947Z"
                  clipRule="evenodd"
                />
              </svg>
              <span className={css(styles.searchText)}>
                {searchText}
              </span>
            </>
          }
        </div>
        {showPlusIcon &&
          <>
            <i
              className={`ml-2 fa fa-plus-circle ${css(styles.caseFieldPlusIcon)}`}
              onClick={handleOnClickPlusIcon}
            />
            <span className={`pl-1 ${css(styles.caseFieldPlusIcon)}`}>
              {`Add ${plusIconLabel}`}
            </span>
          </>
        }
      </div>
      {showIsRequired && <div className={css(styles.requiredText)}>Required</div>}
    </div>
  );
};

CaseField.defaultProps = {
  showAlert: false,
  showIncomplete: false,
  showNoneFlag: false,
  showSearchIcon: false,
  searchText: ''
};

export default CaseField;
